import React from 'react'
import LoginFormContainer from './LoginFormContainer'

const Login = ({ onLogin, from, username, password, onChange, message }) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    handleLogin()
  }
  const handleLogin = () => onLogin({ username, password })
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <form
          className="bg-white rounded-2xl shadow-xl p-8 space-y-6"
          onSubmit={handleSubmit}
        >
          {/* Logo Section */}
          <div className="flex flex-col items-center mb-8">
            <div className="w-32 h-32 mb-4 flex items-center justify-center">
              <img
                className="w-full h-full object-contain"
                src={require('../../img/corla-logo.png')}
                alt="logo"
              />
            </div>
            <h1 className="text-2xl font-semibold text-gray-900">
              Welcome Back
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              Sign in to your account
            </p>
          </div>

          {/* Username Input */}
          <div>
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-700 mb-1.5"
            >
              Username
            </label>
            <input
              id="username"
              type="text"
              name="username"
              value={username}
              onChange={(e) => onChange('username', e.currentTarget.value)}
              placeholder="Enter your username"
              className="w-full px-4 py-3 text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors"
              autoComplete="username"
            />
          </div>

          {/* Password Input */}
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-1.5"
            >
              Password
            </label>
            <input
              id="password"
              type="password"
              name="password"
              value={password}
              onChange={(e) => onChange('password', e.currentTarget.value)}
              placeholder="Enter your password"
              className="w-full px-4 py-3 text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors"
              autoComplete="current-password"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          >
            Sign In
          </button>

          {/* Footer Text */}
          <div className="text-center pt-4">
            <p className="text-xs text-gray-500">Coral Kiosk Application</p>
          </div>
        </form>
      </div>
    </div>
  )
}

const LoginWithForm = (props) => (
  <LoginFormContainer>
    <Login {...props} />
  </LoginFormContainer>
)

export default LoginWithForm
